import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

export type ContextNavigationParams = Record<string, string | number | boolean>;

interface ContextNavigationBlockData {
  '@type'?: string;
  _v_inherit?: boolean;
  _v_inherit_level?: number;
  root_node?: { '@id'?: string }[];
  topLevel?: number | string;
}

interface SlotData {
  blocks?: Record<string, ContextNavigationBlockData>;
  blocks_layout?: { items?: string[] };
}

/**
 * Parâmetros do @contextnavigation do bloco. O bloco e o SSR (`App`) usam este
 * mesmo helper: a chave no Redux sai deles, e o que o servidor carregou só é
 * aproveitado no navegador se a chave bater.
 */
export const contextNavigationParams = (
  data: ContextNavigationBlockData = {},
): ContextNavigationParams => {
  const topLevel = Number(data.topLevel);
  const params: ContextNavigationParams = {
    topLevel: Number.isInteger(topLevel) && topLevel >= 1 ? topLevel : 2,
    bottomLevel: 0,
    currentFolderOnly: false,
  };
  const rootPath = data.root_node?.[0]?.['@id'];
  if (rootPath) {
    params.root_path = flattenToAppURL(rootPath);
  }
  return params;
};

const originDistance = (block: ContextNavigationBlockData): number =>
  block._v_inherit ? block._v_inherit_level ?? Infinity : 0;

/**
 * O bloco de menu de contexto da lateral, nos dados devolvidos por @slots. Mesma
 * regra do `semRepeticao` do SlotRenderer: o bloco da própria página e, na
 * falta dele, o do ancestral mais próximo; empate fica com o primeiro.
 */
export const findContextNavigationBlock = (
  slotItems: Record<string, SlotData> = {},
): ContextNavigationBlockData | null => {
  let chosen: ContextNavigationBlockData | null = null;
  for (const slot of Object.values(slotItems)) {
    const blocks = slot?.blocks || {};
    for (const id of slot?.blocks_layout?.items || []) {
      const block = blocks[id];
      if (block?.['@type'] !== 'contextNavigation') continue;
      if (!chosen || originDistance(block) < originDistance(chosen)) {
        chosen = block;
      }
    }
  }
  return chosen;
};
